<div class="u-h-100">
    <div class="landing-failed-container">

        <div style="border: 1px solid #dc3545; border-radius: 0.25rem; padding: 1rem; background-color: #f8d7da; color: #721c24; text-align: center; max-width: 40rem; margin: 0 auto;">
            <h1 class="u-margin-b-4">Authentication Failed</h1>
            <p class="u-margin-b-5 u-text-muted" style="max-width: 40rem; text-justify: center; margin: 0 auto;">
                We couldn't authenticate your session or the session was interrupted. Please click below to try logging in again.
            </p>

            <button type="button" class="btn btn-outline-danger btn-sm text-start" style="margin-top: 1rem;" (click)="triggerForcedRelogin()">
                Return to Login
            </button>
        </div>
    </div>
</div>
